var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50335 14.8571H15.0748C15.3904 14.8571 15.6462 14.6013 15.6462 14.2857V13.1572C15.6462 12.8416 15.902 12.5857 16.2176 12.5857C16.5332 12.5857 16.7891 12.8416 16.7891 13.1572V14.2857C16.7891 15.2325 16.0216 16 15.0748 16H2.50335C1.55657 16 0.789062 15.2325 0.789062 14.2857V1.71429C0.789062 0.767512 1.55657 0 2.50335 0H15.0748C16.0216 0 16.7891 0.767512 16.7891 1.71429V7.42857C16.7891 7.74416 16.5332 8 16.2176 8C15.902 8 15.6462 7.74416 15.6462 7.42857V5.42857H6.50335V14.8571ZM15.0748 1.14286H2.50335C2.18776 1.14286 1.93192 1.39869 1.93192 1.71429V4.28571H15.6462V1.71429C15.6462 1.39869 15.3904 1.14286 15.0748 1.14286ZM1.93192 14.2857V5.42857H5.36049V14.8571H2.50335C2.18776 14.8571 1.93192 14.6013 1.93192 14.2857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7215 8.20562C13.9235 7.96318 14.2839 7.93042 14.5263 8.13246L16.5835 9.84675C16.7137 9.95531 16.7891 10.1161 16.7891 10.2857C16.7891 10.4553 16.7137 10.6161 16.5835 10.7247L14.5263 12.439C14.2839 12.641 13.9235 12.6083 13.7215 12.3658C13.5195 12.1234 13.5522 11.7631 13.7947 11.561L14.6393 10.8572H12.6176C12.302 10.8572 12.0462 10.6013 12.0462 10.2857C12.0462 9.97014 12.302 9.7143 12.6176 9.7143H14.6393L13.7947 9.01043C13.5522 8.80839 13.5195 8.44807 13.7215 8.20562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.00dc03b5f6357b1617183d638a483bac.svg";
export { ForwardRef as ReactComponent };